import React from 'react'

import Loading from 'components/base/Loading'

import Error from 'components/base/Form/Error'

import Address from 'components/base/Form/Input/Address'
import Date from 'components/base/Form/Input/Date'

import { Type } from 'components/base/Form/Input/types'

import {
  InputWrap,
  InputField,
} from './styles'

import { Props } from './types'

const Input: React.FC<Props> = ({
  alwaysShowError,
  componentType,
  defaultValue,
  error,
  loading,
  pristine,
  touched,
  valid,
  value,
  children, /* eslint-disable-line @typescript-eslint/no-unused-vars */ // avoid react error when passing `children` as prop
  ...props
}): React.ReactElement => {
  if (loading) {
    return <Loading />
  }

  const WrappedInput = (componentType === Type.address && (
    <Address
      {...props}
      alwaysShowError={alwaysShowError}
      pristine={pristine}
      touched={touched}
      valid={valid}
      value={value}
    />
  )) || ((componentType === Type.date || componentType === Type.datetime || componentType === Type.time) && (
    <Date
      {...props}
      alwaysShowError={alwaysShowError}
      touched={touched}
      valid={valid}
      value={value}
    />
  )) || (
    <InputField
      {...props}
      alwaysShowError={alwaysShowError}
      defaultValue={defaultValue as string}
      pristine={pristine}
      touched={touched}
      valid={valid}
      value={value as string}
    />
  )

  return (
    <InputWrap>
      {WrappedInput}
      {(!valid && (touched || alwaysShowError) && (
        <Error name={props.name} alwaysShowError={alwaysShowError} touched={touched}>
          <span>{error}</span>
        </Error>
      )) ||
        undefined}
    </InputWrap>
  )
}

export default Input
